import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import About from '@/components/about'
import Home from '@/components/home'
import DnaerStar from '@/components/dnaerStar'
import DnaerGirlsWeb from '@/components/dnaerGirlsWeb'
import downapp from '@/components/downapp'
import Community from '@/components/html/community'
import UserProtocol from '@/components/html/userProtocol'
import Privacy from '@/components/html/privacy'
import superDnaer1 from '@/components/superDnaer'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/superDNAer',
      component: superDnaer1,
      children: [
        // 河大
        {
          path: '/superDNAer',
          component: superDnaer1,
        },
        //郑大
        {
          path: '/superDNAer/zzu',
          component: superDnaer1,
        },
        // 河南财经政法大学
        {
          path: '/superDNAer/huel',
          component: superDnaer1
        },
        // 洛阳师范学院
        {
          path: '/superDNAer/lynu',
          component: superDnaer1
        },
        // 开封大学
        {
          path: '/superDNAer/kfu',
          component: superDnaer1
        },
      ]
    },
    {
      path: '/dnaerStar',
      name: 'dnaerStar',
      component: DnaerStar
    },
    {
      path: '/dnaerGirlsWeb',
      name: 'dnaerGirlsWeb',
      component: DnaerGirlsWeb
    },
    {
      path: '/downapp',
      name: 'downapp',
      component: downapp
    },
    {
      path: '/index',
      name: 'index',
      component: Index
    },
    {
      path: '/community',
      name: 'community',
      component: Community
    },
    {
      path: '/userProtocol',
      name: 'userProtocol',
      component: UserProtocol
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js